export default "__VITE_ASSET__CUj$73AE__"